/**
 * Tarjeta "Acceso restringido" del panel admin (issue #579).
 *
 * Una sola fuente para el texto. La pintan dos lugares:
 *
 * - `AdminShell`, cuando el usuario no es staff: bloquea todas las rutas
 *   `/admin/*` al montar, antes de que la pagina llegue a pedir nada.
 * - La pagina `Admin`, cuando el backend igual responde 403 (p. ej. le
 *   quitaron el staff con la sesion abierta).
 *
 * El backend sigue siendo la puerta real (R-SEC-008); esto es UX.
 */
export function AdminAccessDenied() {
  return (
    <div
      data-testid="admin-access-denied"
      className="mx-auto max-w-2xl rounded-xl border border-amber-200 bg-amber-50 p-6"
    >
      <h1 className="text-base font-semibold text-amber-900">Acceso restringido</h1>
      <p className="mt-2 text-sm text-amber-800">
        El panel de administración es solo para el equipo interno de Kaptar. Si crees que debes
        tener acceso, escribe a soporte.
      </p>
    </div>
  );
}
